module.exports = __webpack_public_path__ + "c2ea57711a92b03ca700b7cd76049dcc.svg";